import { api } from '@goaltree/backend/convex/_generated/api'
import { useConvexAuth, useQuery } from 'convex/react'

const NO_TRIAL = { active: false, endsAt: null, daysLeft: 0 }

export function useIsPro() {
  const { isAuthenticated } = useConvexAuth()
  const sub = useQuery(api.subscriptions.getMySubscription, isAuthenticated ? {} : 'skip')

  return {
    isPro: sub?.plan === 'pro',
    isLoading: isAuthenticated && sub === undefined,
    tier: sub?.tier ?? 'free',
    trial: sub?.trial ?? NO_TRIAL,
    trialEligible: sub?.trialEligible ?? false,
    cardTrialEligible: sub?.cardTrialEligible ?? false,
    lifetime: sub?.lifetime ?? false,
  }
}
